export enum EUserClass {
	USERS = 'users'
}
export enum EActionEvent {
	FIND,
	GET,
	UPDATE,
	DELETE,
	CREATE
}
export interface IUser {
	id: number | string,
	name: string,
	exercice: IExercice[]
}
export interface IExercice {
	exercice_id: string,
	name: string,
	date: string,
	reps: string,
	weight: string
}
export interface IRequestEvent {
	action: EActionEvent,
	class: any,
	data: Object
}
